import Footer from './Footer';
import FooterHeader from './header';
import FooterBody from './body';
import FooterSub from './sub';
import FooterWrapper from './wrapper';
import FooterMobile from './mobile';
import FooterDesktop from './desktop';
export { Footer, FooterHeader, FooterBody, FooterSub, FooterWrapper, FooterMobile, FooterDesktop };
//# sourceMappingURL=index.js.map